import { hooks } from "./hookactions"
import { actions } from "./actions"
export let QUTOffering = { hooks, actions }
